import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Paper,
  Typography,
  CircularProgress,
  Divider,
  Grid,
} from "@mui/material";
import { AddCircleOutline as AddIcon } from "@mui/icons-material";
import Swal from "sweetalert2";
import PartitionApi from "../../Classes/API/PartitionApi";

const AddPartition = ({ onSuccess }) => {
  const [name, setName] = useState("");
  const [capacity, setCapacity] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !capacity) {
      Swal.fire("Field Required", "Please enter Name and Capacity", "info");
      return;
    }

    setLoading(true);
    try {
      const response = await PartitionApi.CreatePartition({
        name: name,
        capacity: parseInt(capacity),
      });
      console.log(response);
      if (response.data.status === "Success") {
        Swal.fire("Done!", response.data.message, "success");
        setName("");
        setCapacity("");
        if (onSuccess) onSuccess();
      } else {
        Swal.fire("warning", response.data.message, "warning");
      }
    } catch (error) {
      const serverMessage =
        error.response?.data?.message || "Check your connection";
      Swal.fire("Error", serverMessage, "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Paper
      elevation={0}
      sx={{ p: 4, borderRadius: "15px", border: "1px solid #e0e0e0" }}
    >
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 3 }}>
        <AddIcon sx={{ verticalAlign: "middle", mr: 1 }} color="info" />
        Quick Add Partition
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={5}>
            <TextField
              fullWidth
              label="Partition Name"
              variant="outlined"
              placeholder="e.g. Primary Clinic"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Hourly Capacity"
              type="number"
              variant="outlined"
              value={capacity}
              onChange={(e) => setCapacity(e.target.value)}
              required
              InputProps={{ inputProps: { min: 1 } }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                height: "53px",
                backgroundColor: "#1A73E8",
                color: "#fff",
                "&:hover": { backgroundColor: "#1557B0" },
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Create Partition"
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default AddPartition;
